class ToggleVideoTestimonials extends HTMLButtonElement {
  constructor() {
    super();

    this.clickHandler = this.onClick.bind(this);

    this.addEventListener("click", this.clickHandler);
  }

  disconnectCallback() {
    this.removeEventListener("click", this.clickHandler);
  }

  get dialogEl() {
    if (this._dialogEl) {
      return this._dialogEl;
    }

    const controlledId = this.getAttribute("aria-controls");
    if (!controlledId) {
      console.warn("Element does not have aria-controls attribute.");
      return null;
    }

    const dialog = document.querySelector(`dialog#${controlledId}`);
    if (!dialog) {
      console.warn(`No <dialog> element found with id="${controlledId}".`);
    }

    const dialogComponent = dialog.closest("dialog-component");
    if (!dialogComponent) {
      console.warn(`No <dialog-component> element found with id="${controlledId}".`);
    }

    this._dialogEl = dialogComponent;
    return dialogComponent;
  }

  get sliderEl() {
    return (this._sliderEl = this._sliderEl || this.dialogEl.querySelector(".carousel"));
  }

  get testimonialsBlock() {
    return this.closest(".video-testimonials-block");
  }

  publishTestimonialEvent(name, index, videoId) {
    const block = this.testimonialsBlock;
    window.Shopify?.analytics?.publish(name, {
      videoId: videoId ?? null,
      videoIndex: index,
      videoPosition: index + 1,
      videoTotal: Number(block?.dataset.testimonialCount) || null,
      productId: block?.dataset.productId,
    });
  }

  updateActiveCaption(caption) {
    const dialog = this.dialogEl?.querySelector("dialog");
    const captionEl = dialog?.querySelector('[ref="activeCaption"]');
    if (!captionEl) return;
    captionEl.textContent = caption || captionEl.dataset.defaultHeading || "";
  }

  bindSwitchTracking(sliderEl) {
    if (sliderEl._testimonialSwitchTrackingBound) return;
    sliderEl._testimonialSwitchTrackingBound = true;

    const bind = (swiperInstance) => {
      swiperInstance.on("slideChange", () => {
        const index = swiperInstance.params?.loop
          ? (swiperInstance.realIndex ?? 0)
          : (swiperInstance.activeIndex ?? 0);
        const activeSlideEl = swiperInstance.slides?.[index];

        if (activeSlideEl) {
          this.updateActiveCaption(activeSlideEl.dataset.caption);
        }

        if (sliderEl._suppressNextSwitchTrack) {
          sliderEl._suppressNextSwitchTrack = false;
          return;
        }
        const videoId = activeSlideEl?.dataset.videoId;
        this.publishTestimonialEvent("video_testimonial_switch", index, videoId);
      });
    };

    if (sliderEl.swiperInstance) {
      bind(sliderEl.swiperInstance);
    } else {
      sliderEl.addEventListener("carousel:ready", (event) => bind(event.detail.swiperInstance), { once: true });
    }
  }

  onClick(event) {
    event.preventDefault();

    const index = Number(this.dataset.index);
    const videoId = this.dataset.videoId;

    if (!this.dialogEl) {
      return;
    }

    this.updateActiveCaption(this.dataset.caption);

    this.bindSwitchTracking(this.sliderEl);
    this.sliderEl._suppressNextSwitchTrack = true;
    setTimeout(() => { this.sliderEl._suppressNextSwitchTrack = false; }, 500);

    if (this.sliderEl?.swiperInstance) {
      this.sliderEl.goToSlide(index);
    } else {
      this.sliderEl.addEventListener(
        "carousel:ready",
        () => {
          this.sliderEl.goToSlide(index);
        },
        { once: true }
      );
    }

    this.publishTestimonialEvent("video_testimonial_click", index, videoId);

    this.dialogEl.showDialog();
  }
}
customElements.define("toggle-video-testimonials", ToggleVideoTestimonials, { extends: "button" });
